import { NavigationType, sessionStore, updateSession } from "../../stores/session";
import { navigateTo, navigateToPath } from "../../routing";
import { decodeJWT } from "../../public/lib/helpers/jwt";
import { get } from "svelte/store";
import { campaignStore } from "../../stores/campaign";
import PATHS from "../../constants/routePaths";
import { isTestMode } from "../../stores/mode";
import type { Campaign } from "../../../types/campaign";
import { CampaignStatus, checkStatus } from "../../public/lib/api/campaign";
const RENEW_JWT_BEFORE_MS = 10 * 60 * 1000; // 10 minutes

export const start = (): void => {
  const session = get(sessionStore);
  const jwt = session.jwt;

  if (jwt) {
    const decodedJWT = decodeJWT(jwt);
    const channel = decodedJWT.via;

    if (channel === "anonymous") {
      updateSession({ jwt: undefined });
    } else if (decodedJWT.exp * 1000 < (Date.now() + RENEW_JWT_BEFORE_MS)) {
      updateSession({ jwt: undefined });
    }
  }

  navigateTo(NavigationType.Next);
};

export const skippedLandingPageStart = (): void => {
  const campaign = get(campaignStore).campaign as Campaign;

  if (isTestMode()) {
    start();
  } else {
    const status = checkStatus(campaign);
    if (status === CampaignStatus.TEASING) {
      navigateToPath(PATHS.CAMPAIGN_TEASER);
    } else if (status === CampaignStatus.OVER) {
      navigateToPath(PATHS.CAMPAIGN_OVER);
    } else {
      start();
    }
  }
};

